import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <BrowserRouter>
    // <React.StrictMode>
      <App />
    // </React.StrictMode>
  // </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for automatic updates and offline support
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    console.log('New version available! Updating...');
  },
  onSuccess: (registration) => {
    console.log('App is ready for offline use.');
  }
});
